module.exports = __webpack_public_path__ + "img/promo1.17d2ea2c.jpg";